
// src/i18nService.js
import i18n from './i18n';
import { useTranslation } from 'react-i18next';

export const useI18n = (namespaces = []) => {
  // Si on reçoit une string ou un tableau, on normalise en tableau
  const nsArray = Array.isArray(namespaces) ? namespaces : [namespaces];
  // On injecte toujours 'common' en premier
  const finalNamespaces = ['common', ...nsArray.filter((n) => n !== 'common')];
  const { t } = useTranslation(finalNamespaces, { useSuspense: true });
  return { t, i18n };
};